import dayjs from 'dayjs'
import { CalendarDays as CalendarIcon } from 'lucide-react'
import PropTypes from 'prop-types'

import { Button } from '@/components/elements/button'
import { Calendar } from '@/components/elements/calendar'
import { FormControl } from '@/components/elements/form'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/elements/popover'
import { cn } from '@/utils/helpers'

const CalendarInput = ({ className, value = null, onChange, ...props }) => (
  <Popover>
    <PopoverTrigger asChild>
      <FormControl>
        <Button variant="outline" className={cn('w-full justify-between font-normal', className)}>
          {value ? dayjs(value).format('MMM D, YYYY') : 'Select date'}
          <CalendarIcon />
        </Button>
      </FormControl>
    </PopoverTrigger>
    <PopoverContent className="w-auto overflow-hidden p-0" align="start">
      <Calendar
        mode="single"
        selected={value}
        onSelect={onChange}
        captionLayout="dropdown"
        {...props}
      />
    </PopoverContent>
  </Popover>
)

CalendarInput.propTypes = {
  className: PropTypes.string,
  value: PropTypes.instanceOf(Date),
  onChange: PropTypes.func.isRequired,
}

export default CalendarInput
